import React from "react";
import "./EcommerceCheckoutPage.scss"
import success from "../../../assets/success.svg"
import { useHistory } from "react-router";
import Button from "../../../components/Button/Button";
const EcommerceSuccess = () => {
    const history = useHistory()
    return (
        <div className="EcommerceSuccess">
            <div className="EcommerceSuccess-inner-cont">
                <img alt="" src={success} className="success-icon" />
                <div className="EcommerceSuccess-header-text">Thank You!</div>
                <div className="EcommerceSuccess-subheader-text">Your order has been received.</div>
                <div className="EcommerceSuccess-sub-text">We’ve received it successfully. You’ll receive your confirmation email shortly, we appreciate your patience!</div>
                <div className="back-home-btn"
                ><Button text={"Back to Home"}
                    onClick={() => {
                        history.push("/")
                    }} /></div>
            </div>
        </div>
    )
}
export default EcommerceSuccess